/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BookingInvoiceApiResource,
  ChargeBookingRequest,
  CreateManualPaymentRequest,
  PaymentApiResource,
  PostApiBookingCharge400,
  PostApiBookingInvoiceRefund400,
  PostApiBookingPaymentsCreate400,
  PostApiBookingSendPaymentRequest400,
  RefundBookingRequest,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiBookingChargeResponse200 = {
  data: BookingInvoiceApiResource
  status: 200
}

export type postApiBookingChargeResponse400 = {
  data: PostApiBookingCharge400
  status: 400
}

export type postApiBookingChargeResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingChargeResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiBookingChargeResponseSuccess = (postApiBookingChargeResponse200) & {
  headers: Headers;
};
export type postApiBookingChargeResponseError = (postApiBookingChargeResponse400 | postApiBookingChargeResponse401 | postApiBookingChargeResponse403) & {
  headers: Headers;
};

export type postApiBookingChargeResponse = (postApiBookingChargeResponseSuccess | postApiBookingChargeResponseError)

export const getPostApiBookingChargeUrl = (id: string,) => {


  

  return `/api/bookings/${id}/charge`
}

export const postApiBookingCharge = async (id: string,
    chargeBookingRequest: ChargeBookingRequest, options?: RequestInit): Promise<postApiBookingChargeResponse> => {
  
  return customFetch<postApiBookingChargeResponse>(getPostApiBookingChargeUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      chargeBookingRequest,)
  }
);}


export type postApiBookingPaymentsCreateResponse201 = {
  data: PaymentApiResource
  status: 201
}

export type postApiBookingPaymentsCreateResponse400 = {
  data: PostApiBookingPaymentsCreate400
  status: 400
}

export type postApiBookingPaymentsCreateResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingPaymentsCreateResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiBookingPaymentsCreateResponseSuccess = (postApiBookingPaymentsCreateResponse201) & {
  headers: Headers;
};
export type postApiBookingPaymentsCreateResponseError = (postApiBookingPaymentsCreateResponse400 | postApiBookingPaymentsCreateResponse401 | postApiBookingPaymentsCreateResponse403) & {
  headers: Headers;
};

export type postApiBookingPaymentsCreateResponse = (postApiBookingPaymentsCreateResponseSuccess | postApiBookingPaymentsCreateResponseError)

export const getPostApiBookingPaymentsCreateUrl = (id: string,) => {


  

  return `/api/bookings/${id}/payments`
}

export const postApiBookingPaymentsCreate = async (id: string,
    createManualPaymentRequest: CreateManualPaymentRequest, options?: RequestInit): Promise<postApiBookingPaymentsCreateResponse> => {
  
  return customFetch<postApiBookingPaymentsCreateResponse>(getPostApiBookingPaymentsCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createManualPaymentRequest,)
  }
);}


export type postApiBookingInvoiceRefundResponse200 = {
  data: BookingInvoiceApiResource
  status: 200
}

export type postApiBookingInvoiceRefundResponse400 = {
  data: PostApiBookingInvoiceRefund400
  status: 400
}

export type postApiBookingInvoiceRefundResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingInvoiceRefundResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiBookingInvoiceRefundResponseSuccess = (postApiBookingInvoiceRefundResponse200) & {
  headers: Headers;
};
export type postApiBookingInvoiceRefundResponseError = (postApiBookingInvoiceRefundResponse400 | postApiBookingInvoiceRefundResponse401 | postApiBookingInvoiceRefundResponse403) & {
  headers: Headers;
};

export type postApiBookingInvoiceRefundResponse = (postApiBookingInvoiceRefundResponseSuccess | postApiBookingInvoiceRefundResponseError)

export const getPostApiBookingInvoiceRefundUrl = (id: string,) => {


  

  return `/api/booking-invoices/${id}/refund`
}

export const postApiBookingInvoiceRefund = async (id: string,
    refundBookingRequest: RefundBookingRequest, options?: RequestInit): Promise<postApiBookingInvoiceRefundResponse> => {
  
  return customFetch<postApiBookingInvoiceRefundResponse>(getPostApiBookingInvoiceRefundUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refundBookingRequest,)
  }
);}


export type postApiBookingSendPaymentRequestResponse200 = {
  data: BookingInvoiceApiResource
  status: 200
}

export type postApiBookingSendPaymentRequestResponse400 = {
  data: PostApiBookingSendPaymentRequest400
  status: 400
}

export type postApiBookingSendPaymentRequestResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiBookingSendPaymentRequestResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type postApiBookingSendPaymentRequestResponseSuccess = (postApiBookingSendPaymentRequestResponse200) & {
  headers: Headers;
};
export type postApiBookingSendPaymentRequestResponseError = (postApiBookingSendPaymentRequestResponse400 | postApiBookingSendPaymentRequestResponse401 | postApiBookingSendPaymentRequestResponse403) & {
  headers: Headers;
};

export type postApiBookingSendPaymentRequestResponse = (postApiBookingSendPaymentRequestResponseSuccess | postApiBookingSendPaymentRequestResponseError)

export const getPostApiBookingSendPaymentRequestUrl = (id: string,) => {


  

  return `/api/bookings/${id}/send-payment-request`
}

export const postApiBookingSendPaymentRequest = async (id: string, options?: RequestInit): Promise<postApiBookingSendPaymentRequestResponse> => {
  
  return customFetch<postApiBookingSendPaymentRequestResponse>(getPostApiBookingSendPaymentRequestUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}


